import {
  Box,
  Dialog,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect } from "react";

import Referral from "features/Settings/Referral";
import { trackEvent } from "utils/tracking";

interface Props {
  open: boolean;
  close: () => void;
  source?: string;
}

const ReferralDialogNavigation = ({ open, close, source }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (open) {
      trackEvent("Referral Dialog Shown", { source: "Navigation Bar" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onClose={close} fullScreen={isMobileScreen}>
      <IconButton
        aria-label="close"
        onClick={close}
        sx={{
          position: "absolute",
          right: 4,
          top: 4,
          width: 30,
          height: 30,
          color: grey[500],
          fontSize: 16,
        }}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>

      <Box sx={{ p: 3 }}>
        <Referral hideBalance={true} source={source} />
      </Box>
    </Dialog>
  );
};

export default ReferralDialogNavigation;
